var pluralator=function pluralator(count,singular,plural){if(count===1)return singular;return plural;};export default pluralator;